import { render, staticRenderFns } from "./ClientSettings.vue?vue&type=template&id=31b49ede&"
import script from "./ClientSettings.vue?vue&type=script&lang=js&"
export * from "./ClientSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports